export const mapStatusIcon = function(status) {
  const icons = {
    SUCCESS: 'mdi-check-circle-outline',
    FAILED: 'mdi-alert-outline',
    RUNNING: 'mdi-autorenew mdi-spin',
    CANCELLED: 'mdi-close-circle-outline',
    PENDING: 'dots-horizontal-circle-outline'
  }
  return icons[status]
}
export const mapStatusColor = function(status) {
  const colors = {
    SUCCESS: 'green',
    FAILED: 'red',
    RUNNING: 'blue',
    CANCELLED: 'grey',
    PENDING: 'orange'
  }
  return colors[status]
}
